<template>
    <v-flex class="experience-block" v-if="isProfessionalExperienceVisible || isCurrentUser">
        <v-flex id="professionalExperienceBlock">
            <v-flex tag="h2">{{memberProfileConstants.PROFESSIONAL_EXPERIENCE}}<i v-if="isCurrentUser" class="fas fa-pencil-alt ml-2" data-qe-id="professionalExperienceEditIcon" @click="openAllEditDialog()"></i>
                <i class="fas fa-external-link-alt ml-2" data-qe-id="professionalExperienceViewIcon" @click="openViewDialog" v-if="isProfessionalExperienceVisible && !isCurrentUser"></i>
            </v-flex>
            <v-flex>
                <v-flex v-if="!isProfessionalExperienceVisible && isCurrentUser">{{memberProfileConstants.DEFAULT_EDIT_TEXT.PROFESSIONAL_EXP}}</v-flex>
                <status-overlay :action="loadGetProfessionalExperienceAction" content-height="200px">
                </status-overlay>
            </v-flex>
            <v-flex v-if="primaryCompany">
                <v-layout row wrap>
                    <v-flex xs12 class="experience-block__row">
                        <v-flex tag="strong" v-if="primaryCompany.endDate === null">{{memberProfileConstants.PROFESSIONAL_EXP.CURRENT_COMPANY}}</v-flex>
                        <v-flex tag="b">
                            <a
                            v-if="primaryCompany.website"
                            :href="normalizeUrl(primaryCompany.website)"
                            target="_blank"
                            data-qe-id="'primaryCompany_companyNameLink">{{primaryCompany.companyName}}</a>
                        </v-flex>
                        <v-flex tag="b" v-if="!primaryCompany.website">{{primaryCompany.companyName}}</v-flex>
                        <v-flex>{{primaryCompany.jobTitle}} {{displayStartAndEndDate(primaryCompany)}}</v-flex>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-flex  class="experience-block__row" v-if="primaryCompany.presidentType">
                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.PRESIDENT_TYPE}}:</v-flex>
                            <v-flex tag="span" data-qe-id="company_presidentType">{{primaryCompany.presidentType}}</v-flex>
                        </v-flex>
                        <v-flex class="experience-block__row" v-if="primaryCompany.companyType">
                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_TYPE}}:</v-flex>
                            <v-flex tag="span" data-qe-id="company_companyType">{{primaryCompany.companyType}}</v-flex>
                        </v-flex> 
                        <v-flex class="experience-block__row" v-if="primaryCompany.companySize">
                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_SIZE}}:</v-flex>
                            <v-flex tag="span" data-qe-id="company_companySize">{{primaryCompany.companySize}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-flex class="experience-block__row industry" v-if="primaryCompany.industryCategory1 || primaryCompany.industryCategory2 || primaryCompany.industryCategory3">
                            <strong>{{memberProfileConstants.INDUSTRY}}:</strong>
                            <span>{{displayIndustry(primaryCompany)}}</span>
                        </v-flex>
                        <v-flex xs12 sm6 class="experience-block__row" v-if="primaryCompany.scopeofBusiness">
                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.SCOPE}}:</v-flex>
                            <v-flex tag="span" data-qe-id="company_scopeofBusiness">{{primaryCompany.scopeofBusiness}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 class="experience-block__row" v-if="primaryCompany.description">
                        <v-flex data-qe-id="company_description" v-for="(paragraph,p) in divideParagraph(primaryCompany.description)" :key="p">
                            <p>{{paragraph}}</p>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 class="experience-block__row" v-if="primaryCompany.isYouthInternship">
                        <v-flex data-qe-id="company_isYouthInternship">{{memberProfileConstants.PROFESSIONAL_EXP.YOUTH_INTERNSHIP}}</v-flex>
                    </v-flex>
                    <v-flex xs12 class="address" v-if="primaryCompany.street">
                        <v-flex>{{primaryCompany.street}}</v-flex>
                        <v-flex>{{primaryCompany.city}}, {{primaryCompany.state}} {{primaryCompany.postalCode}}</v-flex>
                        <v-flex>{{primaryCompany.country}}</v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-dialog v-model="professionalExperienceViewDialog" scrollable content-class="medium">
                <v-card class="myprofile-popup">
                    <v-card-title primary-title class="model-popup-title">
                        {{memberProfileConstants.PROFESSIONAL_EXPERIENCE}}
                        <i class="fas fa-times" data-qe-id="closeProfessionalExperienceView" @click="professionalExperienceViewDialog = false"></i>
                    </v-card-title>
                    <v-card-text class="inner-scrollbar">
                        <v-flex mr-2 ml-2 class="experience-block" v-if="currentCompanies && currentCompanies.length>0">
                            <v-flex tag="h2">{{memberProfileConstants.PROFESSIONAL_EXP.CURRENT_COMPANIES}}</v-flex>
                            <v-flex v-for="(item,index) in currentCompanies" :key="item.id">
                                <v-layout row wrap>
                                    <v-flex xs12 class="experience-block__row">
                                        <v-flex tag="b">
                                            <a
                                            v-if="item.website"
                                            :href="normalizeUrl(item.website)"
                                            target="_blank"
                                            :data-qe-id="'currentCompany_companyNameLink_'+index">{{item.companyName}}</a>
                                        </v-flex>
                                        <v-flex tag="b" v-if="!item.website">{{item.companyName}}</v-flex>
                                        <v-flex>{{item.jobTitle}} {{displayStartAndEndDate(item)}}</v-flex>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-flex class="experience-block__row" v-if="item.presidentType">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.PRESIDENT_TYPE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'currentCompany_presidentType_'+index">{{item.presidentType}}</v-flex>
                                        </v-flex>
                                        <v-flex class="experience-block__row" v-if="item.companyType">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_TYPE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'currentCompany_companyType_'+index">{{item.companyType}}</v-flex>
                                        </v-flex>
                                        <v-flex class="experience-block__row" v-if="item.companySize">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_SIZE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'currentCompany_companySize_'+index">{{item.companySize}}</v-flex>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-flex class="industry experience-block__row" v-if="item.industryCategory1 || item.industryCategory2 || item.industryCategory3">
                                            <strong>{{memberProfileConstants.INDUSTRY}}:</strong>
                                            <span>{{displayIndustry(item)}}</span>
                                        </v-flex>
                                        <v-flex xs6 class="experience-block__row" v-if="item.scopeofBusiness">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.SCOPE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'currentCompany_scopeofBusiness_'+index">{{item.scopeofBusiness}}</v-flex>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs12 class="experience-block__row" v-if="item.description">
                                        <v-flex :data-qe-id="'currentCompany_description_'+index" v-for="(paragraph,p) in divideParagraph(item.description)" :key="p">
                                            <p>{{paragraph}}</p>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs12 class="experience-block__row" v-if="item.isYouthInternship">
                                        <v-flex :data-qe-id="'currentCompany_isYouthInternship_'+index">{{memberProfileConstants.PROFESSIONAL_EXP.YOUTH_INTERNSHIP}}</v-flex>
                                    </v-flex>
                                    <v-flex xs12 class="address" v-if="item.street || item.city">
                                        <v-flex>{{item.street}}</v-flex>
                                        <v-flex>{{item.city}}, {{item.state}} {{item.postalCode}}</v-flex>
                                        <v-flex>{{item.country}}</v-flex>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-flex>
                        <v-flex mr-2 ml-2 class="experience-block" v-if="formerCompanies && formerCompanies.length>0">
                            <v-flex tag="h2">{{memberProfileConstants.PROFESSIONAL_EXP.FORMER_COMPANIES}}</v-flex>
                            <v-flex v-for="(item,index) in formerCompanies" :key="item.id">
                                <v-layout row wrap>
                                    <v-flex xs12 class="experience-block__row">
                                        <v-flex tag="b">
                                            <a
                                            v-if="item.website"
                                            :href="normalizeUrl(item.website)"
                                            target="_blank"
                                            :data-qe-id="'formarCompany_companyNameLink_'+index">{{item.companyName}}</a>
                                        </v-flex>
                                        <v-flex tag="b" v-if="!item.website">{{item.companyName}}</v-flex>
                                        <v-flex>{{item.jobTitle}} {{displayStartAndEndDate(item)}}</v-flex>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-flex class="experience-block__row" v-if="item.presidentType">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.PRESIDENT_TYPE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'formarCompany_presidentType_'+index">{{item.presidentType}}</v-flex>
                                        </v-flex>
                                        <v-flex class="experience-block__row" v-if="item.companyType">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_TYPE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'formarCompany_companyType_'+index">{{item.companyType}}</v-flex>
                                        </v-flex>
                                        <v-flex class="experience-block__row" v-if="item.companySize">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_SIZE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'formarCompany_companySize_'+index">{{item.companySize}}</v-flex>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-flex class="industry experience-block__row" v-if="item.industryCategory1 || item.industryCategory2 || item.industryCategory3">
                                            <strong>{{memberProfileConstants.INDUSTRY}}:</strong>
                                            <span>{{displayIndustry(item)}}</span>
                                        </v-flex>
                                        <v-flex class="experience-block__row" v-if="item.scopeofBusiness">
                                            <v-flex tag="strong">{{memberProfileConstants.PROFESSIONAL_EXP.SCOPE}}:</v-flex>
                                            <v-flex tag="span" :data-qe-id="'formarCompany_scopeofBusiness_'+index">{{item.scopeofBusiness}}</v-flex>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs12 class="experience-block__row" v-if="item.description">
                                        <v-flex :data-qe-id="'formarCompany_description_'+index" v-for="(paragraph,p) in divideParagraph(item.description)" :key="p">
                                            <p>{{paragraph}}</p>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs12 class="experience-block__row" v-if="item.isYouthInternship">
                                        <v-flex :data-qe-id="'formarCompany_isYouthInternship_'+index">{{memberProfileConstants.PROFESSIONAL_EXP.YOUTH_INTERNSHIP}}</v-flex>
                                    </v-flex>
                                    <v-flex xs12 class="address" v-if="item.street || item.city">
                                        <v-flex>{{item.street}}</v-flex>
                                        <v-flex>{{item.city}}, {{item.state}} {{item.postalCode}}</v-flex>
                                        <v-flex>{{item.country}}</v-flex>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog scrollable v-model="professionalExperienceEditDialog" content-class="medium">
                <v-card class="myprofile-popup">
                    <v-card-title primary-title>
                        {{memberProfileConstants.PROFESSIONAL_EXP.EDIT_MY_PROFESSIONAL_EXPERIENCE}} 
                        <i class="fas fa-times" data-qe-id="closeProfessionalExperienceEditIcon" @click="professionalExperienceEditDialog = false"></i>
                    </v-card-title>
                    <v-card-text class="inner-scrollbar">
                        <v-flex mr-2 ml-2 class="details-view" v-if="currentCompanies && currentCompanies.length>0">
                            <v-flex tag="h2">{{memberProfileConstants.PROFESSIONAL_EXP.CURRENT_COMPANIES}}</v-flex>
                            <v-flex v-for="(item, currentCompany_index) in currentCompanies" :key="item.id">
                                <v-flex tag="strong">{{item.companyName}}<i class="fas fa-pencil-alt" :data-qe-id="'editCurrentCompany_'+currentCompany_index" @click="showProfessionalExperienceAddDialog(item)"></i></v-flex>
                                <v-flex tag="small">{{item.jobTitle}} {{displayStartAndEndDate(item)}}</v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex mr-2 ml-2 class="details-view" v-if="formerCompanies && formerCompanies.length > 0">
                            <v-flex tag="h2">{{memberProfileConstants.PROFESSIONAL_EXP.FORMER_COMPANIES}}</v-flex>
                            <v-flex v-for="(item, formerCompany_index) in formerCompanies" :key="item.id">
                                <v-flex tag="strong">{{item.companyName}}<i class="fas fa-pencil-alt" :data-qe-id="'editFormerCompany_'+formerCompany_index" @click="showProfessionalExperienceAddDialog(item)"></i></v-flex>
                                <v-flex tag="small">{{item.jobTitle}} {{displayStartAndEndDate(item)}}</v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex class="btn-row">
                            <v-btn flat class="primary_btn" data-qe-id="addNewProfessionalExperience" @click="showProfessionalExperienceAddDialog()">
                                <i class="fas fa-plus-circle mr-2"></i> {{memberProfileConstants.ADD_MORE}} 
                            </v-btn>
                        </v-flex>   
                    </v-card-text>
                    <v-card-actions>
                        <v-flex text-xs-right pa-3 uppercase>
                            <v-btn flat class="primary_btn" data-qe-id="closeProfessionalExperienceEditBtn" @click="professionalExperienceEditDialog=false">
                                {{appCommonConstants.CLOSE}}
                            </v-btn>
                        </v-flex>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog scrollable persistent v-model="professionalExperienceAddDialog" v-if="professionalExperienceAddDialog" content-class="medium">
                <v-card class="myprofile-popup professional-experience-popup">
                    <v-card-title primary-title>
                        {{memberProfileConstants.PROFESSIONAL_EXP.EDIT_MY_PROFESSIONAL_EXPERIENCE}}
                        <i class="fas fa-times" data-qe-id="closeProfessionalExperienceAddIcon" @click="hideProfessionalExperienceAddDialog()"></i>
                    </v-card-title>
                    <v-card-text class="inner-scrollbar">
                        <v-form v-for="(record, index) in professionalExperienceRecords" :key="index" :id="index" :ref="`professionalExperienceForm-${record.id}`" v-model="record.isFormValid">
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <v-flex class="currently-work">
                                            <v-checkbox
                                            class="mt-0"
                                            color="ypo_blue"
                                            :label="memberProfileConstants.PROFESSIONAL_EXP.ISWORKINGHERE"
                                            :data-qe-id="'isWorkingHere_'+index"
                                            v-model="record.isWorkingHere"></v-checkbox>
                                        </v-flex>
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_NAME+memberProfileConstants.ASTERISK}}</span>
                                        <v-flex class="autocomplete" v-on:mouseleave="isSearchOpen=false">
                                            <v-text-field
                                                required 
                                                color="ypo_blue" 
                                                :data-qe-id="'companayName_autoComplete_'+index"
                                                :placeholder="memberProfileConstants.TYPE_TO_SEARCH" 
                                                :rules="memberProfileConstants.PROFESSIONAL_EXP.COMPANY_NAME_REQUIRED"
                                                :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY"
                                                v-model="record.companyName" 
                                                @input="fetchEntriesDebounce(record)"
                                                @keydown.down="onArrowDown"
                                                @keydown.up="onArrowUp"
                                                @keydown.enter="onEnter(record)">
                                            </v-text-field>
                                            <v-list v-show="search.length >= memberProfileConstants.THREE && record.isSearchOpen && isSearchOpen"
                                                ref="autocomplete_results" 
                                                id="autocomplete-results" 
                                                class="autocomplete-results">
                                                <v-list-tile
                                                    v-for="(result, i) in results"
                                                    class="autocomplete-result"
                                                    :key="i"
                                                    :data-qe-id="'company_autoComplete_results_'+i"
                                                    @click="setResult(result, record)"
                                                    :class="{ 'is-active': i === arrowCounter }">
                                                    <v-list-tile-title v-highlight = "{keyword: record.companyName, sensitive: false}">
                                                    {{ result }}
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control"><span class="required-label">{{memberProfileConstants.REQUIRED}}</span></v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.BUSINESS_TITLE}}</span>
                                        <v-text-field 
                                        color="ypo_blue" 
                                        :placeholder="memberProfileConstants.PROFESSIONAL_EXP.BUSINESS_TITLE"
                                        :maxlength="memberProfileConstants.MAX_TITLE_LENGTH"
                                        :data-qe-id="'businessTitle_'+index"
                                        v-model="record.jobTitle"></v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.PRESIDENT_TYPE+memberProfileConstants.ASTERISK}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :items="presidentTypes"
                                            item-text="presidentType1"
                                            :data-qe-id="'presidentType'+index"
                                            :placeholder="memberProfileConstants.PROFESSIONAL_EXP.PRESIDENT_TYPE"
                                            v-model="record.businessRole"
                                            :rules="memberProfileConstants.PROFESSIONAL_EXP.PRESIDENT_TYPE_REQUIRED"
                                            required></v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.WEBSITE_ADDR}}</span>
                                        <v-text-field 
                                        color="ypo_blue" 
                                        :placeholder="memberProfileConstants.PROFESSIONAL_EXP.WEBSITE_ADDR"
                                        :maxlength="memberProfileConstants.MAX_TITLE_LENGTH"
                                        :rules="memberProfileConstants.WEBSITE_URL_RULE"
                                        :data-qe-id="'company_website_'+index"
                                        v-model="record.website"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 > 
                                    <span class="select-label pl-2">{{memberProfileConstants.START_DATE+memberProfileConstants.ASTERISK}}</span>
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-flex class="form-control">
                                            <v-autocomplete
                                                attach
                                                color="ypo_blue"
                                                :data-qe-id="'startDateMonth_'+index"
                                                :placeholder="memberProfileConstants.MONTH"
                                                :items="fullMonthNames"
                                                :rules="memberProfileConstants.PROFESSIONAL_EXP.MONTH_REQUIRED"
                                                v-model="record.startDateMonth"
                                                @input="validateEndDate(record)"
                                                required></v-autocomplete>
                                            </v-flex>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-flex class="form-control">
                                            <v-autocomplete
                                                attach
                                                :data-qe-id="'startDateYear_'+index"
                                                :placeholder="memberProfileConstants.YEAR"
                                                color="ypo_blue"
                                                :items="yearDropdownOptions"
                                                :rules="memberProfileConstants.PROFESSIONAL_EXP.YEAR_REQUIRED"
                                                v-model="record.startDateYear"
                                                @input="validateEndDate(record)"
                                                required></v-autocomplete>
                                                </v-flex>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6 class="end-date" v-if="!record.isWorkingHere">
                                    <span class="select-label pl-2">{{memberProfileConstants.END_DATE+memberProfileConstants.ASTERISK}}</span>
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-flex class="form-control">
                                            <v-autocomplete
                                                attach
                                                color="ypo_blue"
                                                :data-qe-id="'endDateMonth_'+index"
                                                :placeholder="memberProfileConstants.MONTH"
                                                :items="fullMonthNames"
                                                :rules="memberProfileConstants.PROFESSIONAL_EXP.MONTH_REQUIRED"
                                                v-model="record.endDateMonth"
                                                @input="validateEndDate(record)"
                                                required></v-autocomplete>
                                            </v-flex>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-flex class="form-control">
                                            <v-autocomplete
                                                attach
                                                color="ypo_blue"
                                                :data-qe-id="'endDateYear_'+index"
                                                :placeholder="memberProfileConstants.YEAR"
                                                :items="yearDropdownOptions"
                                                :rules="memberProfileConstants.PROFESSIONAL_EXP.YEAR_REQUIRED"
                                                v-model="record.endDateYear"
                                                @input="validateEndDate(record)"
                                                required></v-autocomplete>
                                                </v-flex>
                                        </v-flex>
                                    </v-layout>
                                    <span ma-0 class="end-date__validation" v-if="record.invalidDate">{{memberProfileConstants.END_DATE_MUST_BE_GREATER_THAN_START_DATE}}</span>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap class="check-list">
                                <v-flex xs12 class="label-text">
                                    <v-checkbox 
                                    color="ypo_blue"
                                    :label="memberProfileConstants.PROFESSIONAL_EXP.ISPRIMARY_CHECK" 
                                    :data-qe-id="'isPrimary_check_'+index"
                                    @change="validateIsPrimaryField($event,record)"
                                    :disabled="record.isFirstRecord"
                                    v-model="record.isPrimary"></v-checkbox>
                                </v-flex>
                                <v-flex xs12 class="label-text">
                                    <v-checkbox 
                                    color="ypo_blue"
                                    :label="memberProfileConstants.PROFESSIONAL_EXP.ISYOUTHINTERNSHIP" 
                                    :data-qe-id="'isYourthInternship_check_'+index"
                                    v-model="record.isYouthInternship"></v-checkbox>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_TYPE }}</span>
                                        <span v-if="record.isPrimary && !userProfile.ypoGoldBadge" class="select-label">{{memberProfileConstants.ASTERISK}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'companyTypes_'+index"
                                            :items="companyTypes"
                                            item-text="companyType1"
                                            :placeholder="memberProfileConstants.PROFESSIONAL_EXP.COMPANY_TYPE"
                                            :rules="record.isPrimary && !userProfile.ypoGoldBadge ? memberProfileConstants.PROFESSIONAL_EXP.COMPANY_TYPE_REQUIRED : []"
                                            v-model="record.companyType"
                                            :required="record.companyTypeRequired && !userProfile.ypoGoldBadge">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_SIZE }}</span>
                                        <span v-if="record.isPrimary && !userProfile.ypoGoldBadge" class="select-label">{{memberProfileConstants.ASTERISK}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'companySizeDropdown_'+index"
                                            :items="companySizes"
                                            item-text="companySize"
                                            :placeholder="memberProfileConstants.PROFESSIONAL_EXP.COMPANY_SIZE"
                                            :rules="record.isPrimary && !userProfile.ypoGoldBadge ? memberProfileConstants.PROFESSIONAL_EXP.COMPANY_SIZE_REQUIRED : []"
                                            v-model="record.companySize"
                                            :required="record.companySizeRequired && !userProfile.ypoGoldBadge">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.BUSINESS_SCOPE}}</span>
                                        <span v-if="record.isPrimary && !userProfile.ypoGoldBadge" class="select-label">{{memberProfileConstants.ASTERISK}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'busniessScope_'+index"
                                            :items="businessScopes"
                                            item-text="businessScope1"
                                            :placeholder="memberProfileConstants.PROFESSIONAL_EXP.BUSINESS_SCOPE"
                                            :rules="record.isPrimary && !userProfile.ypoGoldBadge ? memberProfileConstants.PROFESSIONAL_EXP.BUSINESS_SCOPE_REQUIRED : []"
                                            v-model="record.scopeofBusiness"
                                            :required="record.scopeofBusinessRequired && !userProfile.ypoGoldBadge">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.INDUSTRY+memberProfileConstants.ASTERISK}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'industryCategory1_'+index"
                                            :items="Object.keys(industries).sort()"
                                            v-on:change="getSubIndustryData($event,record,'subIndustries1','industrySubCategory1',true)"
                                            :placeholder="memberProfileConstants.INDUSTRY"
                                            v-model="record.industryCategory1"
                                            :rules="memberProfileConstants.PROFESSIONAL_EXP.INDUSTRY_CATEGORY_REQUIRED"
                                            required>
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :no-data-text="noSubIndustry(record.subIndustries1, record.industryCategory1)"
                                            :data-qe-id="'industrySubCategory1_'+index"
                                            :items="record.subIndustries1"
                                            :placeholder="memberProfileConstants.SUB_INDUSTRY"
                                            v-model="record.industrySubCategory1">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="record.isVisibleIndustryCategory2">
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'industryCategory2_'+index"
                                            :items="Object.keys(industries).sort()"
                                            v-on:change="getSubIndustryData($event,record,'subIndustries2','industrySubCategory2',true)"
                                            :placeholder="memberProfileConstants.INDUSTRY"
                                            v-model="record.industryCategory2">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :no-data-text="noSubIndustry(record.subIndustries2, record.industryCategory2)"
                                            :data-qe-id="'industrySubCategory2_'+index"
                                            :items="record.subIndustries2"
                                            :placeholder="memberProfileConstants.SUB_INDUSTRY"
                                            v-model="record.industrySubCategory2">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="record.isVisibleIndustryCategory3">
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :data-qe-id="'industryCategory3_'+index"
                                            :items="Object.keys(industries).sort()"
                                            v-on:change="getSubIndustryData($event,record,'subIndustries3','industrySubCategory3',true)"
                                            :placeholder="memberProfileConstants.INDUSTRY"
                                            v-model="record.industryCategory3">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :no-data-text="noSubIndustry(record.subIndustries3, record.industrySubCategory3)"
                                            :data-qe-id="'industrySubCategory3_'+index"
                                            :items="record.subIndustries3"
                                            :placeholder="memberProfileConstants.SUB_INDUSTRY"
                                            v-model="record.industrySubCategory3">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="!(record.isVisibleIndustryCategory2 && record.isVisibleIndustryCategory3)">
                                <v-flex class="btn-row">
                                    <v-btn class="primary_btn" id="add_more_industry_btn" @click="showNextIndustryField(record)">
                                        <i class="fas fa-plus-circle mr-2"></i> {{memberProfileConstants.ADD_MORE_INDUSTRIES}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-divider> </v-divider>
                            <v-layout row wrap> 
                                <v-flex class="form-control">
                                    <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.DESCRIPTION}}</span>
                                    <v-textarea 
                                        color="ypo_blue"
                                        :rows="1"
                                        auto-grow
                                        :counter="1200"
                                        maxLength="1200"
                                        :data-qe-id="'company_description'"
                                        v-model="record.description"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-divider> </v-divider>
                            <v-flex tag="h4" class="company-address">{{memberProfileConstants.PROFESSIONAL_EXP.COMPANY_ADDR}}</v-flex>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.COUNTRY}}</span>
                                        <v-autocomplete
                                            attach 
                                            color="ypo_blue"
                                            :data-qe-id="'countryFld_'+index"
                                            :items="Object.keys(countryAndStates).sort()"
                                            v-on:change="getStates($event,record, true)"
                                            v-model="record.country"
                                            :rules="memberProfileConstants.COUNTRY_REQUIRED"
                                            required></v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.STREET}}</span>
                                        <v-text-field 
                                            color="ypo_blue" 
                                            :data-qe-id="'streetFld_'+index"
                                            :maxlength="memberProfileConstants.MAX_STREET_LENGTH"
                                            :rules="memberProfileConstants.PROFESSIONAL_EXP.STREET_REQUIRED"
                                            required  
                                            v-model="record.street"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.CITY}}</span>
                                        <v-text-field 
                                            color="ypo_blue" 
                                            :data-qe-id="'cityFld_'+index"
                                            :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY"
                                            :rules="memberProfileConstants.PROFESSIONAL_EXP.CITY_REQUIRED"
                                            required  
                                            v-model="record.city"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 v-if="record.showStateField">
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.STATE}}</span>
                                        <v-autocomplete
                                            attach
                                            color="ypo_blue"
                                            :no-data-text="memberProfileConstants.PLEASE_SELECT_COUNTRY"
                                            :data-qe-id="'stateFld_'+index"
                                            :items="record.states"
                                            item-text="stateProvince"
                                            v-model="record.state"
                                            :rules="memberProfileConstants.PROFESSIONAL_EXP.STATE_REQUIRED"
                                            required></v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.PROFESSIONAL_EXP.POSTAL_CODE}}</span>
                                        <v-text-field 
                                            color="ypo_blue" 
                                            :rules="memberProfileConstants.PROFESSIONAL_EXP.POSTAL_CODE_REQUIRED"
                                            :data-qe-id="'postalCodeFld_'+index"
                                            @keypress="zipPostalCodeValidation"
                                            :maxlength="memberProfileConstants.MAX_ZIP_LENGTH"
                                            required                                   
                                            v-model="record.postalCode"></v-text-field>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex class="btn-row">
                                    <v-btn class="primary_btn"
                                        data-qe-id="addMoreProfessionalExperienceBtn"
                                        v-if="!record.isEditDialog" 
                                        :disabled="!record.isFormValid || loadingInProgress || isEndDatesInvalid"
                                        @click="addProfessionalExperience(record)">
                                        <i class="fas fa-plus-circle mr-2"></i> {{memberProfileConstants.ADD_MORE}}
                                    </v-btn>
                                    <v-btn class="primary_btn" 
                                        color="primary"
                                        :data-qe-id="'deleteProfessionalExperienceBtn'+index"
                                        @click="showDeleteConfirmDialog(record.id, index)"
                                        :disabled="!record.isDeletable">
                                        <i class="fas fa-trash-alt mr-2"></i> {{appCommonConstants.DELETE}}
                                    </v-btn>
                                    <v-flex :data-qe-id="'saveSuccessLabel_'+index" class="save-to-profile" v-model="record.isSuccess" v-if="record.isSuccess">
                                        <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-flex xs12 text-xs-center pa-1 :data-qe-id="'allRequiredFieldsLabel'+index" class="error-color" v-if="!record.isFormValid || record.invalidDate">{{memberProfileConstants.ALL_FIELDS_REQUIRED}}</v-flex>
                            <v-dialog v-model="deleteProfessionalExperienceDialog" lazy absolute content-class="post-actions">
                                <v-card>
                                    <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                                        <v-btn data-qe-id="deleteProfessionalExperience_closeIcon" icon @click="deleteProfessionalExperienceDialog=false">
                                            <v-icon size="20">close</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex pt-3 pb-3>{{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}</v-flex>
                                    <v-flex text-xs-right>
                                        <status-bar :action="deleteProfessionalExperienceAction"></status-bar>
                                        <v-btn flat @click="deleteProfessionalExperienceDialog = false" data-qe-id="deleteProfessionalExperience_closebtn" class="primary_btn transparent">
                                            {{memberProfileConstants.CANCEL}}
                                        </v-btn>
                                        <v-btn dark @click="deleteProfessionalExperience()" class="primary_btn" data-qe-id="deleteProfessionalExperience_continueBtn">
                                            {{memberProfileConstants.CONTINUE}}
                                        </v-btn>
                                    </v-flex>
                                </v-card>
                            </v-dialog>
                        </v-form>
                    </v-card-text>
                    <status-bar :action="saveProfessionalExperienceAction"></status-bar>
                    <status-bar :action="editProfessionalExperienceAction"></status-bar>
                    <v-card-actions>
                        <v-flex text-xs-right pa-3 uppercase>
                            <v-btn flat class="primary_btn transparent" data-qe-id="cancelProfessionalExperienceAdd" @click="hideProfessionalExperienceAddDialog()">
                                {{appCommonConstants.CANCEL}}
                            </v-btn>
                            <v-btn class="primary_btn" 
                                data-qe-id="doneProfessionalExperienceAdd"
                                :disabled="!isAllFormsValid || loadingInProgress || isEndDatesInvalid"
                                @click="saveProfessionalExperience(false,true)">
                                {{appCommonConstants.DONE}}
                            </v-btn>
                        </v-flex>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
        </v-flex>
    </template>
    
    <script>
        import { memberProfileConstants, noSubIndustry, filterResults } from "./memberProfile.constants.js";
        import { mapActions, mapGetters, mapState } from "vuex";
        import { normalizeUrl, zipPostalCodeValidation } from "@/common/utils/utils.js";
        import { storeAction } from "../../store/storeActions.constant";
        import { storeGetters } from "../../store/storeGetters.constant";
        import {
            getFullMonthNames,
            getMonthYearFromUtc,
            getMonthFromUtc,
            getYearFromUtc,
        } from "@/common/utils/dateTime";
        import { appCommonConstants } from "../appCommon.constants.js";
        import { uuid } from 'vue-uuid';
        import Vue from 'vue';
        import { eventBus } from '../../main';
        import StatusBar from "../StatusBar/StatusBar";
        import StatusOverlay from '../StatusOverlay/StatusOverlay';
        import { gaDataLayerEvent } from "@/plugins/analytics";
        import { gtmEventName } from "@/plugins/gtmAnalytics";
    
        export default {
            name: 'ProfessionalExperience',
            data: () => ({
                appCommonConstants,
                memberProfileConstants,
                noSubIndustry,
                filterResults,
                normalizeUrl,
                zipPostalCodeValidation,
                fullMonthNames: getFullMonthNames(),
                isAllFormsValid: false,
                isEndDatesInvalid: false,
                loadingInProgress: false,
                deleteProfessionalExperienceDialog: false,
                professionalExperienceViewDialog: false,
                professionalExperienceEditDialog: false,
                professionalExperienceAddDialog: false,
                professionalExperienceRecords: [],
                isSearchOpen: false,
                search: '', 
                results: [],
                arrowCounter: 0,
                selectedRecord: {
                    id: 0,
                    index: 0,
                },
            }),
            components: {
                StatusBar,
                StatusOverlay,
            },
            props: {
                memberId: {
                    type: String,
                    required: true,
                },
            },
            created() {
                this.getProfessionalExperience(this.memberId);
                eventBus.$on('professionalExperienceAddDialog', (() => {
                    if (this.primaryCompany) {
                        this.showProfessionalExperienceAddDialog(this.primaryCompany);
                    } else {
                        this.showProfessionalExperienceAddDialog();
                    }
                }));
            },
            methods: {
                ...mapActions({
                    getProfessionalExperience: `memberProfile/${storeAction.getProfessionalExperience}`,
                    editProfessionalExperienceDetails: `memberProfile/${storeAction.editProfessionalExperience}`,
                    saveProfessionalExperienceDetails: `memberProfile/${storeAction.saveProfessionalExperience}`,
                    deleteProfessionalExperienceDetails: `memberProfile/${storeAction.deleteProfessionalExperience}`,
                    searchProfessionalExperience: `memberProfile/${storeAction.searchProfessionalExperience}`,
                    getUserProfile: `memberProfile/${storeAction.getUserProfile}`,
                }),
                divideParagraph(val) {
                    return val.split(/(\r?\n){2,}/g);
                },
                showDeleteConfirmDialog(primaryId, index) {
                    this.deleteProfessionalExperienceDialog = true;
                    this.selectedRecord.id = primaryId;
                    this.selectedRecord.index = index;
                },
                displayStartAndEndDate(data) {
                    let duration = '';
                    if (data && data.startDate !== null) {
                        duration = `from ${getMonthYearFromUtc(data.startDate)}`;
                        duration += data.endDate !== null ? ` to ${getMonthYearFromUtc(data.endDate)}` : ' to present';
                    }
                    return duration;
                },
                showProfessionalExperienceAddDialog(data) {
                    this.professionalExperienceAddDialog = true;
                    let record = {};
                    if (data) {
                        record = Vue.util.extend({}, data);
                        record.isWorkingHere = false;
                        record.isVisibleIndustryCategory2 = false;
                        record.isVisibleIndustryCategory3 = false;
                        record.isEditDialog = true;
                        record.isDeletable = true;
                        record.invalidDate = false;
                        record.personId = this.memberId;
                        if (this.professionalExperience && this.professionalExperience.length === 1) {
                            record.isPrimary = true;
                            record.isFirstRecord = true;
                            record.isDeletable = false;
                        }                    
                        this.getSubIndustryData(record.industryCategory1, record, 'subIndustries1', 'industrySubCategory1', false);
                        this.getSubIndustryData(record.industryCategory2, record, 'subIndustries2', 'industrySubCategory2', false);
                        this.getSubIndustryData(record.industryCategory3, record, 'subIndustries3', 'industrySubCategory3', false);
    
                        if (record.country !== null) {
                            this.getStates(record.country, record, false);
                        }
                        if (record.startDate !== null) {
                            record.startDateMonth = this.fullMonthNames[getMonthFromUtc(record.startDate)];
                            record.startDateYear = getYearFromUtc(record.startDate);
                        }
                        if (record.endDate !== null) {
                            record.endDateMonth = this.fullMonthNames[getMonthFromUtc(record.endDate)];
                            record.endDateYear = getYearFromUtc(record.endDate);
                        } else {
                            record.isWorkingHere = true;
                        }
                    } else {
                        record.isWorkingHere = false;
                        if (this.professionalExperience.filter(x => x.isActive === true).length === 0) {
                            record.isWorkingHere = true;
                            record.isPrimary = true;
                            record.isFirstRecord = true;
                        }
                        record.isDeletable = false;
                        record.id = 0;
                        record.type = "Business";
                        record.isVisibleIndustryCategory2 = false;
                        record.isVisibleIndustryCategory3 = false;
                        record.isEditDialog = false;
                        record.invalidDate = false;
                        record.showStateField = false;
                        record.personId = this.memberId;
                        record.subIndustries1 = [];
                        record.subIndustries2 = [];
                        record.subIndustries3 = [];
                    }
                    this.professionalExperienceRecords = [];
                    this.professionalExperienceRecords.push(record);
                },
                hideProfessionalExperienceAddDialog() {
                    this.professionalExperienceEditDialog = this.professionalExperience.length > 0;
                    this.professionalExperienceAddDialog = false;
                    this.professionalExperienceRecords = [];
                },
                addProfessionalExperience() {
                    this.saveProfessionalExperience(true, false);
                },
                saveProfessionalExperience(isAddMore, isclose) {
                    const [record] = this.professionalExperienceRecords;
                    if (this.professionalExperienceRecords.length === 1 && record.id !== 0) {
                        const [ref] = this.$refs[`professionalExperienceForm-${record.id}`];
                        if (ref && ref.validate && ref.validate()) {
                            record.isFormValid = true;
                            record.startDate = this.mixMonthAndYear(record.startDateMonth, record.startDateYear);
                            record.endDate = record.isWorkingHere ? null : this.mixMonthAndYear(record.endDateMonth, record.endDateYear);
                            this.loadingInProgress = true;
    
                            this.editProfessionalExperienceDetails(record)
                                .then(() => {
                                    this.loadingInProgress = false;
                                    ref.resetValidation();
                                    if (isclose) {
                                        this.hideProfessionalExperienceAddDialog();
                                    }
                                    setTimeout(() => {
                                      if(this.memberId)
                                          this.getUserProfile(this.memberId);
                                    }, 1000);
                                }).catch(() => {
                                    this.loadingInProgress = false;
                                });
                        } else {
                            record.isFormValid = false;
                        }
                    } else {
                        this.professionalExperienceRecords.forEach((data) => {
                            const [ref] = this.$refs[`professionalExperienceForm-${data.id}`];
                            if (ref && ref.validate && ref.validate()) {
                                ref.resetValidation();
                                data.startDate = this.mixMonthAndYear(data.startDateMonth, data.startDateYear);
                                data.endDate = data.isWorkingHere ? null : this.mixMonthAndYear(data.endDateMonth, data.endDateYear);
                                data.isFormValid = true;
                                if (data.id === 0) {
                                    data.id = this.generateGUID();
                                }
                            } else {
                                data.isFormValid = false;
                                this.isAllFormsValid = false;
                            }
                        });
                        if (this.isAllFormsValid) {
                            this.loadingInProgress = true;
                            this.saveProfessionalExperienceDetails(this.professionalExperienceRecords)
                            .then(() => {
                                this.loadingInProgress = false;
                                if (isclose) {
                                    this.hideProfessionalExperienceAddDialog();
                                }
                                setTimeout(() => {
                                  if (this.memberId)
                                    this.getUserProfile(this.memberId);
                                }, 1000);
                                this.professionalExperienceRecords.forEach((data) => {
                                    data.isDeletable = this.professionalExperience.length > 1;
                                    data.isEditDialog = true;
                                    data.isSuccess = true;
                                    data.isFirstRecord = false;
                                });
                                if (isAddMore) {
                                    const index = this.professionalExperienceRecords.length;    
                                    const newRecord = {};
                                    newRecord.isEditDialog = false;
                                    newRecord.isWorkingHere = false;
                                    newRecord.isDeletable = false;
                                    newRecord.isFirstRecord = false;
                                    newRecord.invalidDate = false;
                                    newRecord.id = 0;  
                                    newRecord.type = "Business";
                                    newRecord.isVisibleIndustryCategory2 = false;
                                    newRecord.isVisibleIndustryCategory3 = false;
                                    newRecord.showStateField = false;
                                    newRecord.personId = this.memberId;     
                                    setTimeout(() => {
                                        document.getElementById(index).scrollIntoView();
                                    }, 100);
                                    this.professionalExperienceRecords.push(Vue.util.extend({}, newRecord));
                                }
                            }).catch(() => {
                                this.loadingInProgress = false;
                            });
                        }
                    }
                  gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Experience - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                },
                deleteProfessionalExperience() {
                    const parms = {
                        primaryId: this.selectedRecord.id,
                        personId: this.memberId,
                    };
                    this.loadingInProgress = true;
                    this.deleteProfessionalExperienceDetails(parms)
                    .then(() => {
                        this.loadingInProgress = false;
                        this.deleteProfessionalExperienceDialog = false; 
                        if (this.professionalExperienceRecords.length === 1) {
                            this.hideProfessionalExperienceAddDialog();
                            if (this.professionalExperience.length === 1) {
                                this.professionalExperienceEditDialog = false;  
                            }       
                        } else {
                            Vue.delete(this.professionalExperienceRecords, this.selectedRecord.index);
                        }
                        this.professionalExperienceRecords.forEach((data) => {
                            data.isDeletable = this.professionalExperience.length > 1;
                            const [ref] = this.$refs[`professionalExperienceForm-${data.id}`];
                            if (ref && ref.resetValidation) {
                                ref.resetValidation();
                            }
                        });
                        setTimeout(() => {
                          if(this.memberId)
                            this.getUserProfile(this.memberId);
                        }, 1000);
                    });
                },
                getSubIndustryData(value, record, subIndustries, industrySubCategory, isOnChange) {
                    if (record) {
                        if (value) {
                            record[subIndustries] = this.industries[value];
                            if (isOnChange) {
                                record[industrySubCategory] = null;
                            }
                        } else {
                            record[subIndustries] = [];
                        }
                    } 
                },
                getStates(value, record, isOnChange) {
                    if (record) {
                        const states = this.countryAndStates[value];
                        record.states = states ? states.filter(x => x.stateProvince !== null) : [];
                        record.showStateField = record.states.length > 0;
                        if (isOnChange) {
                            record.state = null;
                        }
                    }
                },
                generateGUID() {
                    return uuid.v1();
                },
                getSearchResults(record) {
                    this.search = record.companyName;
                    if (this.search.length >= this.memberProfileConstants.THREE) {
                        this.searchProfessionalExperience(this.search)
                        .then(() => {
                            this.results = this.filterResults(this.companyNameSearchResults, record.companyName);
                            record.isSearchOpen = this.results.length > 0;
                            this.isSearchOpen = this.results.length > 0;
                            this.arrowCounter = -1;
                        });
                    }
                },
                fetchEntriesDebounce(record) {
                    clearTimeout(this.timerId);
                    this.timerId = setTimeout(() => {
                        this.getSearchResults(record);
                    }, 500);
                },
                onEnter(record) {
                    const selected = this.results[this.arrowCounter];
                    this.setResult(selected, record);
                },
                setResult(result, record) {
                    record.companyName = result;
                    record.isSearchOpen = false;
                    this.isSearchOpen = false;
                    this.arrowCounter = -1;
                },
                onArrowDown() {
                    const [ref] = this.$refs.autocomplete_results;
                    if (this.arrowCounter < this.results.length) {
                        this.arrowCounter = this.arrowCounter + 1;
                        if (this.arrowCounter >= 3 && ref && ref.$el) {
                            ref.$el.scrollTop += 56;
                        }
                    } else {
                        this.arrowCounter = 0;
                        if (ref && ref.$el) {
                            ref.$el.scrollTop = 0;
                        }
                    }
                },
                onArrowUp() {
                    const [ref] = this.$refs.autocomplete_results;
                    if (this.arrowCounter > 0) {
                        this.arrowCounter = this.arrowCounter - 1;
                        if (this.arrowCounter >= 3 && ref && ref.$el) {
                            ref.$el.scrollTop -= 56;
                        }
                    } else {
                        this.arrowCounter = (this.results.length - 1);
                        if (ref && ref.$el) {
                            ref.$el.scrollTop = ref.$el.scrollHeight - 56;
                        }
                    }
                },
                showNextIndustryField(data) {
                    if (!data.isVisibleIndustryCategory2) {
                        data.isVisibleIndustryCategory2 = true;
                    } else {
                        data.isVisibleIndustryCategory3 = true;   
                    }
                },
                displayIndustry(data) {
                    let strIndustry = '';
                    if (data) {
                        if (data.industryCategory1 !== null) {
                            strIndustry = data.industryCategory1;
                            if (data.industrySubCategory1 !== null) {
                                strIndustry += `: ${data.industrySubCategory1}`;
                            }
                        }
                        if (data.industryCategory2 !== null) {
                            strIndustry += `; ${data.industryCategory2}`;
                            if (data.industrySubCategory2 !== null) {
                                strIndustry += `: ${data.industrySubCategory2}`;
                            }
                        }
                        if (data.industryCategory3 !== null) {
                            strIndustry += `; ${data.industryCategory3}`;
                            if (data.industrySubCategory3 !== null) {
                                strIndustry += `: ${data.industrySubCategory3}`;
                            }
                        }
                    }
                    return strIndustry;
                },
                mixMonthAndYear(month, year) {
                    let date = null;
                    if (month && year) {
                        date = new Date(year, this.fullMonthNames.indexOf(month), 1).toLocaleDateString();
                    }
                    return date;
                },
                validateIsPrimaryField(value, record) {
                if (this.professionalExperienceRecords.length > 1) {
                    this.professionalExperienceRecords.filter(x => x.id !== record.id)
                        .forEach((data) => {
                            if (value) {
                            data.isPrimary = false;
                            data.companyTypeRequired = false; 
                            data.companySizeRequired = false; 
                            data.scopeofBusinessRequired = false; 
                            } else {
                            data.isPrimary = true;
                            data.companyTypeRequired = true; 
                            data.companySizeRequired = true; 
                            data.scopeofBusinessRequired = true;
                            }
                            });
                    }
                },
                validateEndDate(data) {
                    if (data) {
                        if (data.startDateYear && data.startDateMonth && data.endDateYear && data.endDateMonth) {                        
                            data.invalidDate = false;
                            if (data.startDateYear > data.endDateYear) {
                                data.invalidDate = true;
                            } else if (data.startDateYear === data.endDateYear) {
                                if (this.fullMonthNames.indexOf(data.startDateMonth) > this.fullMonthNames.indexOf(data.endDateMonth)) {
                                    data.invalidDate = true;
                                }
                            }                        
                        }
                    }
                },
                openAllEditDialog() {
                    if (this.professionalExperience && this.professionalExperience.length > 0) {
                        this.professionalExperienceEditDialog = true;                   
                    } else {
                        this.showProfessionalExperienceAddDialog();
                    }
                },
                openViewDialog() {
                    this.professionalExperienceViewDialog = true;
                },
            },
            computed: {
                ...mapGetters({
                    professionalExperience: `memberProfile/${storeGetters.professionalExperience}`,
                    currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                    isProfessionalExperienceVisible: `memberProfile/${storeGetters.isProfessionalExperienceVisible}`,
                    businessScopes: `memberProfile/${storeGetters.businessScopes}`,
                    companyTypes: `memberProfile/${storeGetters.companyTypes}`,
                    companySizes: `memberProfile/${storeGetters.companySizes}`,
                    countryAndStates: `memberProfile/${storeGetters.countryAndStates}`,
                    presidentTypes: `memberProfile/${storeGetters.presidentTypes}`,
                    industries: `memberProfile/${storeGetters.industory}`,
                    companyNameSearchResults: `memberProfile/${storeGetters.professionalExperienceSearchResults}`,
                    chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
                    userProfile: `memberProfile/${storeGetters.userProfile}`,
                }),
                ...mapState("actionState", ["actions"]),
                primaryCompany() {
                    if (this.professionalExperience && this.professionalExperience.length > 0) {
                        return this.professionalExperience.filter(item => item.isPrimary === true && item.isActive === true).length > 0 ?
                        this.professionalExperience.filter(item => item.isPrimary === true && item.isActive === true)[0] :
                        this.professionalExperience.filter(item => item.isActive === true)[0];
                    }
                    return null;
                },
                currentCompanies() {
                    return this.professionalExperience && this.professionalExperience.length > 0 ?
                        this.professionalExperience.filter(item => item.endDate === null && item.isActive === true) :
                        null;
                },
                formerCompanies() {
                    return this.professionalExperience && this.professionalExperience.length > 0
                        ? this.professionalExperience.filter(item => item.endDate !== null && item.isActive === true)
                        : null;
                },
                isCurrentUser() {
                    return this.memberId === this.currentUserId || this.chapterAdminEditable;
                },
                yearDropdownOptions() {
                    const currentYear = new Date().getFullYear();
                    const years = [];
                    for (let y = currentYear; y >= 1900; y -= 1) {
                        years.push(y);
                    }
                    return years;
                },
                AllFormsValid() {
                    return this.professionalExperienceRecords.map(x => x.isFormValid);
                },
                saveProfessionalExperienceAction() {
                    return this.actions[storeAction.saveProfessionalExperience];
                },
                editProfessionalExperienceAction() {
                    return this.actions[storeAction.editProfessionalExperience];
                },
                deleteProfessionalExperienceAction() {
                    return this.actions[storeAction.deleteProfessionalExperience];
                },
                AllEndDatesInvalid() {
                    return this.professionalExperienceRecords.map(x => x.invalidDate);
                },
                loadGetProfessionalExperienceAction() {
                    return this.actions[storeAction.getProfessionalExperience];
                },
                isRedirectFromConnectPlus() {
                  return this.$route && this.$route.query
                      && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
                },
            },
            watch: {
                AllFormsValid: {
                    handler(newval, oldval) {
                        if (newval !== oldval) {
                            this.isAllFormsValid = this.AllFormsValid.filter(x => x === false).length === 0;
                        }
                    },
                    deep: true,
                },
                AllEndDatesInvalid: {
                    handler(newval, oldval) {
                        if (newval !== oldval) {
                            this.isEndDatesInvalid = this.AllEndDatesInvalid.filter(x => x === true).length > 0;
                        }
                    },
                    deep: true,
                },
            },
        };
    </script>
    
    <style lang="scss" scoped>
        @import "../../common/styles/_colors.scss";
    
        .companies-block {
            border-bottom: 1px solid $ypo-open-blue-gray;
            margin-top: 5px;
        }
    
        .experience-block {
            position: relative;
            margin-top: 20px;
            margin-bottom: 20px;
            background: $white;
            border-bottom: 1px solid $ypo-medium-gray;
            padding: 0 20px 24px 20px;
            &:last-child{
                border-bottom: none;
            }
    
            .address {           
                color: $black;       
            }
    
            &__row {
                margin-bottom: 5px;
                color: $ypo-gray-text;
                font-size: 14px;
                line-height: 25px;
    
                strong {
                    color: $ypo_blue;
                    margin-right: 5px;
                }
    
                span {
                    font-size: 14px;
                    line-height: 24px;
                }
    
                b {
                    display: block;
                    a {
                        color: $ypo-cta;  
                        text-decoration: none;
                    }
                }
    
                .email-link {
                    text-transform: initial;
                    text-decoration: none;
                    font-size: 14px;
                    line-height: 24px;
                    margin-top: -5px;
                    letter-spacing: 0.29px;
                    padding-left: 0px;
                }
    
                p {
                    margin-top: 10px;
                    text-align: justify;
                }
    
                .industry {
                    position: relative;
                    strong {
                        float: left;
                        position: absolute;
                    }
                    span {
                        display: flex;
                        padding-left: 72px;
                    }
                }
            }
    
            p {
                margin-bottom: 20px;
            }
            @media (max-width: 1199px){
                padding: 0 0 24px 0;
            }
            .overlay {
                top: 35px;
            }
        }
    
        h2 {
            color: $ypo_blue;
            font-family: "Raleway", sans-serif;
            font-size: 22px;
            font-weight: 500;
            margin-bottom: 20px;
            line-height: 26px;
    
            span {
                color: $ypo-cta;
                font-size: 14px;
                font-weight: bold;
                line-height: 19px;
                cursor: pointer;
            }
    
            i {
                color: $ypo-dark-background-gray;
                font-size: 14px;
                position: relative;
                left: 5px;
                margin-right: 15px;
                cursor: pointer;
            }
    
            em {
                color: $ypo-cta;
                font-family: "Noto Sans";
                font-size: 14px;
                line-height: 24px;
                font-style: normal;
                margin-left: 10px;
                cursor: pointer;
            }
        }
    
        .myprofile-popup {
    
            h2 {
                color: $ypo-blue;
                font-family: "Raleway", sans-serif;
                font-size: 16px;
                font-weight: bold;
                margin: 0 0 10px 0px;
                line-height: 26px;
            }
    
            .btn-row {
                border-bottom: none;
                margin: 5px 0 5px 2px;
                padding: 0 0 5px 0px;
            }
    
            .details-view {
                border-top: 2px solid $ypo-medium-gray;
                border-bottom: none;
                padding-top: 20px;
                margin: 10px 0 20px 0;
                &:first-child {
                    border-top: none;
                    padding-top: 0;
                }
    
                strong {
                    margin-left: 30px;
                    i {
                        margin-left:10px;
                    }
                }
    
                small {
                    margin-left: 30px;
                }
                
            }
        
        }
    
        .end-date {
            position: relative;
            &__validation{
                position: absolute;
                color: $ypo-red;
                font-size: 12px;
                bottom: 0;
            }
        }
    
        .error-msg {
            color: $ypo-red;
        }
        .professional-experience-popup{
            .v-divider{
                margin: 25px 10px 20px;
            }
            h4{
                    margin: 0 0 20px 10px;
            }
        }
        .model-popup-title {
            padding-left: 18px;
        }   
    </style>
    